import axios from "axios";
const url = process.env.REACT_APP_API_KEY;

export const GetAllFinancingRequests= (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({ 
    method: 'post',
    url: `${url}FinancingRequest/GetCustomerFinancingRequests`,
    data:body,
    headers
    })
    .then(response => onSuccess(response)) 
    .catch(err => onFail(err)); 
}

export const GetFinancingRequestDetails = (id, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }

  axios({ 
    method: 'get',
    url: `${url}FinancingRequest/GetFinancingRequestDetails?FinancingRequestId=${id}`,
    headers
    })
    .then(response => onSuccess(response)) 
    .catch(err => onFail(err)); 
}

export const UploadFinancingRequestFile = (body, onSucess, onFail) => {
  const headers = {
    'Content-Type': 'multipart/form-data',   
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "post",
    url: `${url}FinancingRequest/UploadFinancingRequestFile`,
    data: body, 
    headers,
    }) 
    .then((response) => onSucess(response))
    .catch((err) => onFail(err));
};

export const deleteDoc = (id, onSucess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "delete",
    url: `${url}FinancingRequest/DeleteFinancingRequestFile?FinancingRequestFileId=${id}`,
    headers,
    })
    .then((response) => onSucess(response))
    .catch((err) => onFail(err));
};

export const DeleteIndebtedness = (id, onSucess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "delete",
    url: `${url}Indebtedness/DeleteIndebtedness?IndebtednessId=${id}`, 
    headers
    })
    .then((response) => onSucess(response))
    .catch((err) => onFail(err));
};

export const GetObligations= (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({ 
    method: 'get',
    url: `${url}Obligations/GetObligations${body}`,
    headers
    })
    .then(response => onSuccess(response)) 
    .catch(err => onFail(err)); 
}

export const GetCustomerObligations= (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({ 
    method: 'get',
    url: `${url}Obligations/GetCustomerObligations${body}`,
    headers
    })
    .then(response => onSuccess(response)) 
    .catch(err => onFail(err)); 
}

export const GetCustomerAllObligations= (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({ 
    method: 'get',
    url: `${url}Obligations/GetCustomerObligations?FinancingRequestId=0&page=0`,
    headers
    })
    .then(response => onSuccess(response)) 
    .catch(err => onFail(err)); 
}

export const AddOrUpdateObligation= (body,onSuccess,onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({ 
    method: 'post',
    url: `${url}Obligations/AddOrUpdateObligation`,
    data:body,
    headers
    })
    .then(response => onSuccess(response)) 
    .catch(err => onFail(err)); 
}

export const AddOrUpdateFinancingRequestForCustomer= (body,onSuccess,onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({ 
    method: 'post',
    url: `${url}FinancingRequest/AddOrUpdateFinancingRequestForCustomer`,
    data:body,
    headers
    })
    .then(response => onSuccess(response)) 
    .catch(err => onFail(err)); 
}

export const DeleteObligation = (id, onSucess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({
    method: "delete",
    url: `${url}Obligations/DeleteObligation?ObligationId=${id}`,
    // data: body,
    headers,
    })
    .then((response) => onSucess(response))
    .catch((err) => onFail(err));
};

export const GetAllComments= (body,onSuccess,onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({ 
    method: 'get',
    url: `${url}Comments/GetAllComments?FinancingRequestId=${body.Id}&Page=${body.Page}`,
    headers
    })
    .then((response) => onSuccess(response))
    .catch(err => onFail(err)); 
}

export const AddOrUpdateComment= (body,onSuccess,onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({ 
    method: 'post',
    url: `${url}Comments/AddOrUpdateComment`,
    data:body,
    headers
    })
    .then(response => onSuccess(response)) 
    .catch(err => onFail(err)); 
}

export const DeleteComment= (id,onSuccess,onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({ 
    method: 'delete',
    url: `${url}Comments/DeleteComment?CommentId=${id}`,
    headers
    })
    .then((response) => onSuccess(response)) 
    .catch(err => onFail(err)); 
}

export const DeleteReply= (id,onSuccess,onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({ 
    method: 'delete',
    url: `${url}Comments/DeleteReply?ReplyId=${id}`,
    headers
    })
    .then((response) => onSuccess(response))
    .catch(err => onFail(err)); 
}

export const AddOrUpdateReply= (body,onSuccess,onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({ 
    method: 'post',
    url: `${url}Comments/AddOrUpdateReply`,
    data:body,
    headers
    })
    .then((response) => onSuccess(response))
    .catch(err => onFail(err)); 
}

export const UploadMediationContractFile = (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({ 
    method: 'post',
    url: `${url}FinancingRequest/UploadMediationContractFile`,
    data:body,
    headers
    })
    .then(response => onSuccess(response)) 
    .catch(err => onFail(err)); 
}

export const CalculateFinancingRequestAccounting = (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  axios({ 
    method: 'post',
    url: `${url}FinancingRequest/CalculateFinancingRequestAccounting`,
    data:body,
    headers
    })
    .then(response => onSuccess(response)) 
    .catch(err => onFail(err)); 
}